module.exports = __webpack_public_path__ + "img/svm-2.203cabcf.png";